<template>
<v-container fluid grid-list-lg>
  <v-layout row wrap>
    <v-flex>
      <v-card>
        <v-card-title primary-title class="primary white--text headline">
          Annotation Task Form
        </v-card-title>
        <v-card-text>
          <form>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.id"
                label="ID">
                </v-text-field>
              </v-flex>
              <v-flex xs6>
                <v-text-field
                disabled
                v-model="item.createdDate"
                label="Created Date"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs6>
                <v-text-field
                type="number"
                v-validate="'required|min_value:10'"
                data-vv-name="target count"
                :error-messages="errors.collect('target count')"
                v-model.number="item.targetCount"
                label="Target Count">
                </v-text-field>
              </v-flex>
              <v-flex xs4>
                <v-menu
                  ref="menu"
                  :close-on-content-click="false"
                  v-model="datePickerMenu"
                  :nudge-right="40"
                  :return-value.sync="expireDateDate"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="computedDateFormatted"
                    v-validate="'required'"
                    data-vv-name="expire date"
                    :error-messages="errors.collect('expire date')"
                    label="Expire Date"
                    readonly
                  ></v-text-field>
                  <v-date-picker v-model="expireDateDate" no-title scrollable :min="now" @input="$refs.menu.save(expireDateDate)">
                  </v-date-picker>
                </v-menu>
              </v-flex>
              <v-flex xs2>
                <v-menu
                  ref="menu2"
                  :close-on-content-click="false"
                  v-model="timePickerMenu"
                  :nudge-right="40"
                  :return-value="expireDateTime"
                  lazy
                  transition="scale-transition"
                  offset-y
                  full-width
                  min-width="290px"
                >
                  <v-text-field
                    slot="activator"
                    v-model="expireDateTime"
                    v-validate="'required'"
                    data-vv-name="expire time"
                    :error-messages="errors.collect('expire time')"
                    label="Expire Time"
                  ></v-text-field>
                  <v-time-picker v-model="expireDateTime" format="24hr" @change="$refs.menu2.save(expireDateTime)"></v-time-picker>
                </v-menu>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>
                <v-combobox
                small-chips
                deletable-chips
                v-validate="'required'"
                data-vv-name="annotator"
                :error-messages="errors.collect('annotator')"
                v-model="item.annotator"
                item-text="text"
                item-value="value"
                :items="annotators"
                :multiple="isNew"
                label="Annotator"
                :persistent-hint="isNew"
                :hint="isNew ? 'Multiple annotation tasks will be created for every selected annotator' : ''">
                </v-combobox>
              </v-flex>
            </v-layout>
          </form>
        </v-card-text>
        <v-card-actions style="background: hsl(0, 0%, 97%)" class="pa-3">
          <v-spacer></v-spacer>
          <v-btn color="grey darken-1" flat depressed @click.native="cancel" :disabled="saveLoading">Cancel</v-btn>
          <v-btn color="accent" class="white--text" depressed @click.native="validateBeforeSubmit(save)" :loading="saveLoading" :disabled="saveLoading">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</v-container>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import Vue from 'vue'

export default {
  name: 'annotation-task-item',
  props: {
    annotationWorkId: {
      type: String,
      required: true,
      default: ''
    },
    id: {
      type: String,
      required: false,
      default: ''
    }
  },
  created () {
    this.axios.get(`/annotators`)
      .then(r => {
        this.annotators = r.data.filter((a) => {
          return a.is_active
        }).map((a) => {
          return {
            value: a.id,
            text: `${a.first_name} ${a.last_name}`,
            email: a.email
          }
        })
        if (!this.isNew) {
          this.setLoader({
            loading: true
          })
          this.fetchAnnotationTask()
        }
      })
      .catch(e => {
        this.handleAxiosError(e)
      })
  },
  data () {
    return {
      item: {
        id: '',
        annotator: '',
        annotationCount: 0,
        targetCount: undefined,
        status: 0,
        expireDate: ''
      },
      expireDateDate: null,
      expireDateTime: null,
      saveLoading: false,
      annotators: [],
      datePickerMenu: false,
      timePickerMenu: false
    }
  },
  computed: {
    isNew () {
      return this.id == null || this.id === ''
    },
    now () {
      return moment().add(1, 'd').format('YYYY-MM-DD')
    },
    computedDateFormatted () {
      return this.formatDate(this.expireDateDate)
    },
    computedTimeFormatted () {
      return this.formatTime(this.expireDateTime)
    },
    computedDateTimeFormatted () {
      return this.parseDateTime(this.expireDateDate, this.expireDateTime)
    }
  },
  methods: {
    cancel () {
      this.$router.push({name: 'annotationWorkEdit', params: { id: this.annotationWorkId, stepProp: 1 }})
    },
    formatDate (date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    parseDateTime (date, time) {
      if (!date) return null
      if (!time) time = '00:00'
      let formatted = moment(`${date} ${time}:00`).utc().format()
      return formatted
    },
    fetchAnnotationTask () {
      this.axios.get(`/annotation-works/${this.annotationWorkId}/annotation-tasks/${this.id}`)
        .then(response => {
          this.setAnnotationTaskItem(response.data)
        })
        .catch(error => {
          this.handleAxiosError(error)
        })
        .finally(() => {
          this.setLoader({
            loading: false
          })
        })
    },
    setAnnotationTaskItem (item) {
      item = this.mapAnnotationTaskItem(item)
      const [date, time] = item.expireDate.split(' ')
      this.expireDateDate = moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD')
      this.expireDateTime = time
      this.item = item
      this.item.id = this.id
      this.item.createdDate = item.createdDate
    },
    mapAnnotationTaskItem (annotationTask) {
      return {
        annotator: this.annotators.filter(a => { return a.value === annotationTask.annotator })[0],
        targetCount: annotationTask.target_count,
        annotationCount: annotationTask.annotation_count,
        status: annotationTask.status,
        expireDate: Vue.options.filters.formatDate(annotationTask.expire_date),
        createdDate: Vue.options.filters.formatDate(annotationTask.created_date)
      }
    },
    save () {
      this.saveLoading = true
      let itemToSave = {
        annotator: Array.isArray(this.item.annotator) ? this.item.annotator.map(a => a.value) : [this.item.annotator.value],
        annotation_type: this.item.annotationType,
        target_count: this.item.targetCount,
        expire_date: this.computedDateTimeFormatted
      }

      if (this.isNew) {
        this.axios.post(`/annotation-works/${this.annotationWorkId}/annotation-tasks`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.saveLoading = false
            this.setLoader({
              loading: false
            })
            this.$router.push({name: 'annotationWorkEdit', params: { id: this.annotationWorkId, stepProp: 1 }})
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      } else {
        itemToSave.annotator = itemToSave.annotator[0]
        this.axios.put(`/annotation-works/${this.annotationWorkId}/annotation-tasks/${this.item.id}`, itemToSave)
          .then(response => {
            this.setSnack({
              message: 'Successful',
              type: 'success'
            })
            this.saveLoading = false
            this.setLoader({
              loading: false
            })
            this.$router.push({name: 'annotationWorkEdit', params: { id: this.annotationWorkId, stepProp: 1 }})
          })
          .catch(error => {
            this.handleAxiosError(error)
          })
          .finally(() => {
            this.saveLoading = false
          })
      }
    },
    ...mapActions({
      setSnack: 'snackbar/setSnack',
      setLoader: 'loader/setLoader'
    })
  },
  watch: {
    saveLoading (val) {
      this.setLoader({
        loading: val
      })
    }
  }
}
</script>

<style>

</style>
